import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";

export const getAIProviders = async () => {
	try {
		const response = await API.get(`${Apis.AIProviders}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getAIConfigurations = async () => {
	try {
		const response = await API.get(`${Apis.AIConfigurations}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getAIConfigurationById = async (id) => {
	try {
		const response = await API.get(`${Apis.AIConfigurations}/${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const createAIConfiguration = async (payload) => {
	try {
		const response = await API.post(`${Apis.AIConfigurations}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const updateAIConfiguration = async (id, payload) => {
	try {
		const response = await API.patch(
			`${Apis.AIConfigurations}/${id}`,
			payload
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const deleteAIConfiguration = async (id) => {
	try {
		const response = await API.delete(`${Apis.AIConfigurations}/${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const testAIConfiguration = async (id) => {
	try {
		const response = await API.post(`${Apis.AIConfigurations}/${id}/test`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getGlossaryEntries = async (siteAppId) => {
	try {
		const response = await API.get(`${Apis.AIGlossaries}/SiteApp/${siteAppId}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const createGlossaryEntry = async (payload) => {
	try {
		const response = await API.post(`${Apis.AIGlossaries}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const updateGlossaryEntry = async (id, payload) => {
	try {
		const response = await API.put(`${Apis.AIGlossaries}/${id}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const importGlossaryCsv = async ({ siteAppId, targetLanguage, file }) => {
	try {
		const form = new FormData();
		form.append("siteAppId", String(siteAppId));
		form.append("targetLanguage", targetLanguage);
		form.append("file", file);
		const response = await API.post(`${Apis.AIGlossaries}/ImportCsv`, form, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const exportGlossaryCsv = async (siteAppId, targetLanguage = null) => {
	try {
		const url = targetLanguage
			? `${Apis.AIGlossaries}/SiteApp/${siteAppId}/Export?targetLanguage=${encodeURIComponent(targetLanguage)}`
			: `${Apis.AIGlossaries}/SiteApp/${siteAppId}/Export`;
		const response = await API.get(url, { responseType: "blob" });
		return { status: true, data: response.data };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const downloadGlossaryTemplate = async () => {
	try {
		const response = await API.get(`${Apis.AIGlossaries}/Template`, {
			responseType: "blob",
		});
		return { status: true, data: response.data };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const deleteGlossaryEntry = async (id) => {
	try {
		const response = await API.delete(`${Apis.AIGlossaries}/${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const translateTexts = async ({
	targetLanguage,
	country,
	items,
	siteAppID,
}) => {
	try {
		const response = await API.post(`${Apis.AITranslations}/translate`, {
			targetLanguage,
			country,
			items,
			siteAppID,
		});
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
